import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React, { useCallback, useContext, useState } from 'react';

import { deleteHealthInsurances, HealthInsurancesModel } from 'api/hs/health-insurances';
import { AlertContext } from 'context/alert.context';
import { DialogContext } from 'context/dialog.context';

import { HealthInsurancesContext } from '../../health-insurances.context';

interface Props {
  data: HealthInsurancesModel;
}

export default function Action({ data }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const { setSelectedData, setEditDialogOpened, reload } = useContext(HealthInsurancesContext);
  const { openWarnDialog } = useContext(DialogContext);
  const openMenu = useCallback((e: React.MouseEvent) => setAnchorEl(e.target as HTMLElement), []);
  const closeMenu = useCallback(() => setAnchorEl(null), []);
  const { showMessage } = useContext(AlertContext);

  const openDeleteDialog = useCallback(async () => {
    closeMenu();

    const submitted = await openWarnDialog({
      text: `${data.agencyName} - Sigorta Acentesi kaydını silmek istediğinize emin misiniz ?`,
    });
    try {
      if (submitted) {
        await deleteHealthInsurances(data.id);
        showMessage('Silme işlemi başarılı.', 'success');
        reload();
      }
    } catch (e) {
      showMessage('Silme işleminde sorun oluştu.', 'error');
    }
  }, [closeMenu, data, reload, openWarnDialog, showMessage]);

  const openEditDialog = useCallback(() => {
    setSelectedData(data);
    setEditDialogOpened(true);
    closeMenu();
  }, [closeMenu, setEditDialogOpened, setSelectedData, data]);

  return (
    <>
      <IconButton onClick={openMenu}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={!!anchorEl} onClose={closeMenu}>
        <MenuItem onClick={openDeleteDialog}>
          <ListItemIcon>
            <DeleteIcon fontSize="medium" />
          </ListItemIcon>
          <Typography variant="inherit">Sil</Typography>
        </MenuItem>
        <MenuItem onClick={openEditDialog}>
          <ListItemIcon>
            <EditIcon fontSize="medium" />
          </ListItemIcon>
          <Typography variant="inherit">DÜZENLE</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
